import script from "./BirthRecordDetailPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./BirthRecordDetailPanel.vue?vue&type=script&lang=ts&setup=true"

import "./BirthRecordDetailPanel.vue?vue&type=style&index=0&id=f7e972a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7e972a6"]])

export default __exports__